import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { FaEye, FaEyeSlash, FaEnvelope, FaLock, FaUser, FaIdCard } from "react-icons/fa";
import NavBar from "../NavBar";
import Footer from "../Footer";
import "../Styles/AuthPages.css";
import API_BASE_URL from "../../config";

const Signup = () => {
    const [formData, setFormData] = useState({
        fullName: "",
        email: "",
        password: "",
        universityId: ""
    });
    const { fullName, email, password, universityId } = formData;
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(""); // Clear previous errors
        try {
            const res = await axios.post(
                `${API_BASE_URL}/api/auth/signup`,
                formData,
                { withCredentials: true }
            );
            if (res && res.data) {
                alert(res.data.message || "Signup successful! Please login.");
                navigate("/login");
            }
        } catch (err) {
            console.error(err.response?.data || err.message);
            alert(err.response?.data?.message || "Signup failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page-wrapper">
            <NavBar />
            <div className="auth-page-container">
                <div className="auth-page-card signup-card">
                    <div className="auth-page-header">
                        <h1>Create Account</h1>
                        <p>Join our community today</p>
                    </div>

                    <form onSubmit={handleSubmit} className="auth-page-form signup-form">
                        {/* Two Column Layout */}
                        <div className="signup-grid">
                            <div className="auth-form-group">
                                <label><FaUser /> Full Name</label>
                                <input
                                    type="text"
                                    placeholder="Enter your full name"
                                    value={fullName}
                                    onChange={(e) => setFormData({ ...formData, fullName: e.target.value })}
                                    required
                                    autoComplete="name"
                                />
                            </div>

                            <div className="auth-form-group">
                                <label><FaEnvelope /> Email Address</label>
                                <input
                                    type="email"
                                    placeholder="Enter your email"
                                    value={email}
                                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                    required
                                    autoComplete="email"
                                />
                            </div>

                            <div className="auth-form-group">
                                <label><FaLock /> Password</label>
                                <div className="auth-password-wrapper">
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        placeholder="Create a password"
                                        value={password}
                                        onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                                        required
                                        autoComplete="new-password"
                                        minLength="6"
                                    />
                                    <button
                                        type="button"
                                        className="auth-password-toggle"
                                        onClick={() => setShowPassword(!showPassword)}
                                        tabIndex="-1"
                                    >
                                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                                    </button>
                                </div>
                            </div>

                            <div className="auth-form-group">
                                <label><FaIdCard /> University ID</label>
                                <input
                                    type="text"
                                    placeholder="Enter your university ID"
                                    value={universityId}
                                    onChange={(e) => setFormData({ ...formData, universityId: e.target.value })}
                                    required
                                />
                            </div>
                        </div>

                        <button type="submit" className="auth-page-submit" disabled={loading}>
                            {loading ? "Creating Account..." : "Sign Up"}
                        </button>
                    </form>

                    <div className="auth-page-footer">
                        <p>
                            Already have an account?{" "}
                            <Link to="/login" className="auth-page-link">
                                Log In
                            </Link>
                        </p>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Signup;
